module.exports = __webpack_public_path__ + "static/media/blogBg.19096622.png";